var _templateObject = _taggedTemplateLiteralLoose(['\n  height: ', ';\n  max-height: 80px;\n  width: ', ';\n  @media(max-width: 700px){\n    width: 86px;\n  }\n'], ['\n  height: ', ';\n  max-height: 80px;\n  width: ', ';\n  @media(max-width: 700px){\n    width: 86px;\n  }\n']);

function _taggedTemplateLiteralLoose(strings, raw) {
  strings.raw = raw;
  return strings;
}

import React from 'react';
import styled, { withTheme } from 'styled-components';
import SimplyLogo from './simply.svg';
import SimplyLogoWhite from './simply-white.svg';
import SimplyLogoAnimated from './simply-animated.svg';
import OldMutual from '../../../assets/old_mutual_logo.png';
import { wrapAssetPath } from '../../../utils';
var Img = styled.img(_templateObject, function (props) {
  return props.height;
}, function (props) {
  return props.width;
});

var Logo = function Logo(props) {
  var white = props.white,
      width = props.width,
      logoPathPrefix = props.logoPathPrefix,
      animated = props.animated;
  var LogoWidth = width || 'auto';
  var LogoHeight = width ? 'auto' : '80px';
  var path = SimplyLogo;

  if (path === 'white' || white) {
    path = SimplyLogoWhite;
  }

  if (path === 'animated' || animated) {
    path = SimplyLogoAnimated;
  }

  var fullPath = logoPathPrefix ? '' + logoPathPrefix + path : wrapAssetPath(props.theme, path);
  return React.createElement(Img, {
    width: LogoWidth,
    height: LogoHeight,
    src: fullPath,
    alt: 'Simply'
  });
};

export default withTheme(Logo);